module.exports = __webpack_public_path__ + "img/standard-mercer-call.b6a455a8.png";